$(document).ready(function() {
  var list_credit_packages = document.querySelectorAll('.list-credit-packages');
  list_credit_packages.forEach(el => {
    el.addEventListener('click', () => {
      var dataCreditPackage = el.querySelector('#data-credit-package');
      if (dataCreditPackage != null) {
        var dataset = dataCreditPackage.dataset

        var credit_balance_text = `${dataset.creditAmountCurrency} Credit Balance`
        if (parseInt(dataset.bonusAmount) >= 1) {
          credit_balance_text += ` + Bonus ${dataset.bonusAmountCurrency}`
        }
        document.querySelector('#credit-balance').textContent = credit_balance_text
        document.querySelectorAll('#total-pay-amount').forEach(totalPayAmount => {
          totalPayAmount.textContent = dataset.priceCurrency
        })
        document.querySelector('#credit-amount').textContent = dataset.creditAmountCurrency
        var bonus_amount_text = `${dataset.bonusAmountCurrency}`
        if ((parseInt(dataset.bonusExpiredIn) || 0) >= 1) {
          bonus_amount_text += ` <span class='text-danger'>(Expires: ${dataset.bonusExpiredIn} Days)</span>`
        }
        document.querySelector('#bonus-amount').innerHTML      = bonus_amount_text
        document.querySelector('#terms-condition').innerHTML   = dataset.termsCondition
        document.querySelector('#credit-package-id').value     = dataset.id
      }

      document.querySelector('#btn-buy-now').removeAttribute('disabled');
    })
  })
})
